import {OptionType} from 'platform/components';

import i18n from '@dms/i18n';

export const XENTRY_POSITION_TYPE_OPTIONS: OptionType[] = [
  {
    label: i18n.t('entity.orderRequest.xentryPositionType.customerRequest'),
    value: 'CUSTOMER_REQUEST',
  },
  {
    label: i18n.t('entity.orderRequest.xentryPositionType.maintenance'),
    value: 'MAINTENANCE',
  },
  {
    label: i18n.t('entity.orderRequest.xentryPositionType.complaint'),
    value: 'COMPLAINT',
  },
];
